import {
  NAMESPACE,
  SHOW_LOGS,
  DEFAULT_LOG_TEMPLATE
} from './constants';

const
  {Cookies, RSVP} = window,
  UserType = Object.freeze({
    ANONYMOUS:  'anonimo',
    REGISTERED: 'registrado',
    SUBSCRIBER: 'suscriptor',
    TRIAL:      'trial'
  }),
  _vocUid  = decodeURIComponent(Cookies.get('voc_uid')),
  _cookie  = _vocUid === 'undefined' ? {} : JSON.parse(_vocUid),
  _scripts = {},
  _hasOwnProperty = Object.prototype.hasOwnProperty
;

/**
 * Look for the namespace config
 * @param {string} namespace
 */
export function lookup(namespace = NAMESPACE, root) {
  return namespace.split('.').reduce((that, o) => {
    return o in that ? that[o] : {};
  }, root || window);
}

/**
 * Adapted User type from Gigya for advertising segmentation
 *
 * @return {string}
 */
export const getUserType = window.__VOONTO__ && window.__VOONTO__.getUserType ?
  window.__VOONTO__.getUserType :
  function() {
    var userType, paywall, pwUserType;

    userType = UserType.ANONYMOUS; // <'anonimo' | 'registrado' | 'trial' | 'suscriptor'>
    paywall  = Cookies.get('voc_paywall');
    if (paywall) {pwUserType = paywall.split('|').pop();}

    if (pwUserType) {
      userType = pwUserType;
    } else if (_cookie.uid) {
      userType = UserType.REGISTERED;
    }

    return userType;
  }
;

/**
 * Load file
 *
 * @param {string} url
 * @param {object} options
 */
export function load(url, options = {}) {
  var script, src, key;

  src = url;
  key = url.split('?').shift();
  if (_hasOwnProperty.call(_scripts, key)) {return RSVP.resolve(_scripts[key]);}

  script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  script.async = true;
  if (options.text) {script.text = options.text;}

  return new RSVP.Promise((resolve, reject) => {
    script.onload  = (/*event*/) => resolve(script);
    script.onerror = reject;
    _scripts[key]  = script;

    document.head.appendChild(script);
  });
}

export function showLog() {
  SHOW_LOGS && console.log(DEFAULT_LOG_TEMPLATE, ...arguments);
}

export function showWarn() {
  SHOW_LOGS && console.warn(DEFAULT_LOG_TEMPLATE, ...arguments);
}

export function showError() {
  SHOW_LOGS && console.error(DEFAULT_LOG_TEMPLATE, ...arguments);
}



// WEBPACK FOOTER //
// ./src/utils.js